type ParkingLotModalProps = {
  draft: string;
  labels: {
    title: string;
    close: string;
    description: string;
    placeholder: string;
    cancel: string;
    save: string;
  };
  onChangeDraft: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
};

export function ParkingLotModal({ draft, labels, onChangeDraft, onClose, onSave }: ParkingLotModalProps) {
  return (
    <div className="sheet-overlay" onClick={onClose}>
      <div className="sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-header">
          <h3>{labels.title}</h3>
          <button onClick={onClose}>{labels.close}</button>
        </div>
        <div className="small">{labels.description}</div>
        <textarea
          placeholder={labels.placeholder}
          value={draft}
          maxLength={280}
          onChange={(e) => onChangeDraft(e.target.value)}
        />
        <div className="timer-buttons">
          <button onClick={onClose}>{labels.cancel}</button>
          <button onClick={onSave}>{labels.save}</button>
        </div>
      </div>
    </div>
  );
}
